import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Waves, Utensils, Beer, MessageCircle, MapPin, Clock, Calendar, Snowflake } from 'lucide-react';
import { Footer } from '../components/Footer';
import { ContactSection } from '../components/ContactSection';
import { MensMorningRegistration } from '../components/MensMorningRegistration';
import { UtmCapture } from '../components/UtmCapture';
import { useScreenInit } from '../useScreenInit.js';
const EVENT_DATE = 'שישי, 06.11.2026';
const EVENT_TIME = '08:30 - 13:00';
const PRICE = 480;
const WHATSAPP_MESSAGE = encodeURIComponent('היי נחום, אני רוצה להירשם לבוקר גברים על המים');
const WHATSAPP_URL = `https://wa.me/972522632784?text=${WHATSAPP_MESSAGE}`;
const activities = [{
  icon: Waves,
  title: 'חתירה בכנרת',
  description: 'יוצאים למסלול חתירה שמתאים לכולם - אתגר, הרבה טבע, ובלי צורך בניסיון קודם.',
  image: 'https://cdn.magicpatterns.com/uploads/djoCEQg8hmwmjSjbEKsdqE/image.png'
}, {
  icon: Utensils,
  title: 'בראנץ׳',
  description: 'יושבים לבראנץ׳ טוב, אוכלים יחד ומורידים הילוך אחרי החתירה.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/4166cc98-9918-4195-8857-f75114858b7f.jpg'
}, {
  icon: Beer,
  title: 'בירה קרה',
  description: 'כי אחרי חתירה טובה, מגיעה בירה טובה.',
  image: ''
}, {
  icon: MessageCircle,
  title: 'שיח על החיים',
  description: 'בלי הרצאות ובלי קלישאות - שיחה פתוחה בין גברים על עבודה, זוגיות, משפחה והדרך שלנו.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b517e7a1-4d1c-4061-bc25-e408235f6f30.jpg'
}, {
  icon: Snowflake,
  title: 'אמבטיית קרח',
  description: 'מסיימים בהתנסות מודרכת באמבטיית קרח - נשימה, נוכחות והזדמנות לגלות מה יש מעבר לקצה.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/2e5b80bc-3134-464c-a7dd-2fd629b07247.jpg'
}];
const forWhoPoints = ['אין צורך להיות גולש או ספורטאי', 'רק להגיע עם ראש פתוח, בגדי ים ורצון לצאת ליום אחר', 'מתאים לגברים מעל גיל 18 ולכל רמת כושר'];
export function MensMorningOnWaterPage() {
  const screenInit = useScreenInit();
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(Boolean(screenInit.isRegistrationOpen));
  useEffect(() => {
    document.title = "בוקר גברים על המים | ביץ' קלאב מעגן";
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'בוקר גברים על המים עם נחום שחר, 6.11.2026: חתירה, בראנץ׳, בירה, שיח על החיים ואמבטיית קרח על חוף הכנרת.');
  }, []);
  const openRegistration = () => {
    setIsRegistrationOpen(true);
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'בוקר גברים על המים',
        content_category: 'Mens Morning On Water',
        value: PRICE,
        currency: 'ILS'
      });
    }
  };
  const isPaidIframe = typeof window !== 'undefined' && window.parent !== window && (new URLSearchParams(window.location.search).get('paid') === '1' || new URLSearchParams(window.location.search).get('Response') === '000');
  if (isPaidIframe) {
    return <MensMorningRegistration isFormOpen={false} onFormOpenChange={() => undefined} returnOnly data-id="element-1358" data-mp="37fs9tguuklyr" />;
  }
  return <div className="min-h-screen bg-white" dir="rtl" data-id="element-1359" data-mp="3chrecu2bpoxa">
      <UtmCapture data-id="element-1360" data-mp="3hg2oz70g03gk" />

      {/* Hero */}
      <header className="relative min-h-[92vh] flex items-end overflow-hidden" data-id="element-1361" data-mp="3hcwwdhslujg3">
        <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-1362" data-mp="3lg346tvd8ioo">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/ef1b0b23-2287-46ee-a83c-012851ba9107.jpg" alt="שני גברים חותרים על סאפ בכנרת בזריחה" className="absolute inset-y-0 left-1/2 h-full w-[125%] max-w-none -translate-x-1/2 object-cover object-center sm:w-[115%]" data-id="element-1363" data-mp="1n1s0iznrfbbb" />
          <div className="absolute inset-0 bg-slate-950/65" data-id="element-1364" data-mp="rqa8se5wzd9v" />
        </div>

        <div className="absolute top-5 sm:top-7 inset-x-4 z-20 flex justify-center" data-id="element-1365" data-mp="15pjshntbwpil">
          <span className="inline-flex items-center justify-center gap-2 bg-slate-950/85 border border-amber-300/40 text-amber-100 px-4 py-2 rounded-full text-sm sm:text-base font-semibold text-center shadow-lg" data-id="element-1366" data-mp="10r8gp7jh44xq">
            <Calendar className="w-4 h-4 shrink-0" data-id="element-1367" data-mp="83vsyu1ktr2u" />
            {EVENT_DATE} · {EVENT_TIME}
          </span>
        </div>

        <div className="container mx-auto px-4 relative z-10 pt-32 pb-14 md:pb-20" data-id="element-1368" data-mp="mt1qmdkrn98m">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} className="max-w-3xl mx-auto text-center" data-id="element-1369" data-mp="i08o7wcrsczp">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-black text-white mb-5 leading-[1.08]" data-id="element-1370" data-mp="20zonfwfp6n6g">
              בוקר גברים על המים
            </h1>
            <p className="text-xl md:text-2xl text-slate-200 font-medium mb-2" data-id="element-1371" data-mp="25r6p6mpjorsh">
              יום גברים בכנרת
            </p>
            <p dir="rtl" className="text-lg md:text-xl text-slate-300 leading-relaxed mb-8 max-w-xl mx-auto" data-id="element-1372" data-mp="1rwxattb35ld8">
              חותרים. אוכלים. שותים. מדברים על החיים.
            </p>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-4" data-id="element-1373" data-mp="2jqpjocpfo4mb">
              <button type="button" onClick={openRegistration} className="inline-flex items-center justify-center gap-2 bg-amber-400 hover:bg-amber-300 text-slate-950 font-bold text-lg py-4 px-7 rounded-xl shadow-lg transition-colors" data-id="element-1374" data-mp="2oor3izuoo7yu">
                הרשמה ותשלום
              </button>
              <span className="inline-flex items-center gap-2 text-slate-300" data-id="element-1375" data-mp="1495zot1a7edj">
                <MapPin className="w-5 h-5 text-amber-300" data-id="element-1376" data-mp="1472zxhabu6vm" />
                חוף מעגן, כנרת
              </span>
            </div>
          </motion.div>
        </div>
      </header>

      <main data-id="element-1377" data-mp="310a8opqzk0y3">
        {/* Intro */}
        <section className="py-16 md:py-20 bg-white" data-id="element-1378" data-mp="2w8jvmc0nyz2z">
          <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-1379" data-mp="2w78p44fu3d86">
            <p className="text-2xl md:text-3xl font-bold text-slate-900 leading-snug mb-4" data-id="element-1380" data-mp="2s65epxgk29ec">
              יום אחד לעצור הכול, לצאת למים, להזיע, לצחוק הרבה ולדבר באמת.
            </p>
          </div>
        </section>

        {/* About Nahum */}
        <section className="py-16 md:py-20 bg-slate-50" data-id="element-1381" data-mp="2ib3loqj5sn6h">
          <div className="container mx-auto px-4" data-id="element-1382" data-mp="2daz93bldgclj">
            <div className="grid md:grid-cols-[0.7fr_1.3fr] gap-10 md:gap-14 items-center max-w-5xl mx-auto" data-id="element-1383" data-mp="298c9upmdfpeb">
              <motion.div initial={{
              opacity: 0,
              scale: 0.96
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4
            }} className="relative overflow-hidden rounded-3xl bg-slate-900 shadow-xl" data-id="element-1384" data-mp="bib0empykwyd">
                <img src="https://cdn.magicpatterns.com/uploads/eXUBAtnS9dPyoWzap3BTLR/image.png" alt="נחום שחר עומד על גלשן סאפ בכנרת" className="block w-full aspect-[4/5] object-cover object-center" data-id="element-1385" data-mp="1ucnld2fdyqye" />
                <div className="absolute inset-x-0 bottom-0 bg-slate-950/80 px-5 py-4 text-center" data-id="element-1386" data-mp="16g0172mg10j0">
                  <p className="text-amber-200 font-bold text-lg" data-id="element-1387" data-mp="1bejrtgbzf0hp">
                    לצאת מאזור הנוחות
                  </p>
                </div>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4
            }} data-id="element-1388" data-mp="1fire76uyw4cr">
                <p className="text-sm font-bold text-amber-700 mb-3" data-id="element-1389" data-mp="2vu53uafjf0e3">
                  עליי
                </p>
                <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4" data-id="element-1390" data-mp="27j5wtb51s887">
                  נחום שחר
                </h2>
                <div className="space-y-4 text-slate-700 leading-relaxed text-lg" data-id="element-1391" data-mp="22kund1inzzqi">
                  <p data-id="element-1392" data-mp="2gb7ressfquak">
                    ב־25 השנים האחרונות אני מטפל באנשים, ובשנים האחרונות גם
                    מדריך ספורט ימי - סאפ וגלישת ווינג פויל.
                  </p>
                  <p data-id="element-1393" data-mp="2q7j8rx6vuabv">
                    אני יודע שאפשר להפוך כמעט כל קושי למקור של התפתחות,
                    ושדווקא כשאנחנו יוצאים מאזור הנוחות - קורים הדברים
                    המעניינים באמת.
                  </p>
                  <p data-id="element-1394" data-mp="2z8qvrj3y7oqn">
                    אני אוהב לקחת אנשים לקצה - לא כדי לשבור אותם, אלא כדי
                    לגלות איתם מה יש מעבר לקצה.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* What we do */}
        <section className="py-16 md:py-20 bg-white" data-id="element-1395" data-mp="10uz8v2a9azpq">
          <div className="container mx-auto px-4" data-id="element-1396" data-mp="qpzcmwmrz2a0">
            <div className="max-w-2xl mx-auto text-center mb-12" data-id="element-1397" data-mp="qq930lbqfbg8">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3" data-id="element-1398" data-mp="urkkg3kgcqdc">
                אז מה עושים?
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-1399" data-mp="gxtmlsg32uxg">
              {activities.map((activity, index) => <motion.div key={activity.title} initial={{
              opacity: 0,
              y: 18
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: Math.min(index * 0.06, 0.18)
            }} className="bg-white rounded-2xl border border-slate-200 overflow-hidden flex flex-col" data-id="element-1400" data-mp="71grcq4w490l" data-mpi={index}>
                  {activity.image ? <div className="h-44 overflow-hidden" data-id="element-1401" data-mp="1sd07v7nwoniy">
                      <img src={activity.image} alt={activity.title} className="w-full h-full object-cover" data-id="element-1402" data-mp="1xd4jokdvcu2u" />
                    </div> : <div className="h-44 bg-slate-900 flex items-center justify-center" data-id="element-1403" data-mp="p0gpxs3gmg2p">
                      <activity.icon className="w-12 h-12 text-amber-300" data-id="element-1404" data-mp="oynhq8d77nsl" />
                    </div>}
                  <div className="p-5" data-id="element-1405" data-mp="1grw9tedmtop8">
                    <div className="flex items-center gap-2 mb-2" data-id="element-1406" data-mp="1gsxvsdw6rvlq">
                      <activity.icon className="w-5 h-5 text-amber-600 shrink-0" data-id="element-1407" data-mp="1lr960pqe884h" />
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-1408" data-mp="17r86bdlv76ql">
                        {activity.title}
                      </h3>
                    </div>
                    <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1409" data-mp="1co82mwswwv4i">
                      {activity.description}
                    </p>
                  </div>
                </motion.div>)}
            </div>
            <p className="text-center text-xl font-bold text-slate-900 mt-10" data-id="element-1410" data-mp="3oz9ggvgg01tc">
              ובעיקר - יום של כיף.
            </p>
          </div>
        </section>

        {/* For who */}
        <section className="py-16 md:py-20 bg-slate-900 text-white" data-id="element-1411" data-mp="3l00o9v11wbzw">
          <div className="container mx-auto px-4 max-w-2xl text-center" data-id="element-1412" data-mp="2rjegvey7eov">
            <h2 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-1413" data-mp="3ty2tynvqbsti">
              למי זה מתאים?
            </h2>
            <ul className="space-y-4 text-right inline-block" data-id="element-1414" data-mp="369jp6ibw1y66">
              {forWhoPoints.map(point => <li key={point} className="flex items-start gap-3" data-id="element-1415" data-mp="31b9sg3aimpig">
                  <span className="w-2 h-2 rounded-full bg-amber-400 shrink-0 mt-2.5" data-id="element-1416" data-mp="3fyuudtvnmios" />
                  <span className="text-lg text-slate-200" data-id="element-1417" data-mp="3b7cu781ggm4v">{point}</span>
                </li>)}
            </ul>
            <div className="mt-10 border-t border-slate-700 pt-8 space-y-1" data-id="element-1418" data-mp="2nh8sj67tuwgi">
              <p className="text-lg text-slate-300" data-id="element-1419" data-mp="2ijpea6b4qjok">כנראה שנחזור עייפים.</p>
              <p className="text-xl font-bold text-white" data-id="element-1420" data-mp="mg2j78z12mwl">
                בטוח שנחזור עם משהו לקחת איתנו.
              </p>
            </div>
          </div>
        </section>

        {/* Registration CTA */}
        <section className="py-14 bg-amber-50" data-id="element-1421" data-mp="w647o1vam7c1">
          <div className="container mx-auto px-4 flex flex-col md:flex-row md:items-center md:justify-between gap-6 max-w-5xl" data-id="element-1422" data-mp="w6dz7tvzkmju">
            <div data-id="element-1423" data-mp="109aat0n3ziea">
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3" data-id="element-1424" data-mp="3hgfdmc4mhoz">
                בא לכם להיות חלק מהיום הזה?
              </h2>
              <div className="flex flex-wrap gap-x-5 gap-y-2 text-slate-700" data-id="element-1425" data-mp="8h2wi6v2si32">
                <span className="inline-flex items-center gap-2" data-id="element-1426" data-mp="chll7s1o9811"><Calendar className="w-4 h-4 text-amber-700" data-id="element-1427" data-mp="cjzim7jtqwbr" />{EVENT_DATE}</span>
                <span className="inline-flex items-center gap-2" data-id="element-1428" data-mp="hi9deh1mzuwu"><Clock className="w-4 h-4 text-amber-700" data-id="element-1429" data-mp="1nxa86jexe71u" />{EVENT_TIME}</span>
              </div>
            </div>
            <button type="button" onClick={openRegistration} className="inline-flex items-center justify-center bg-slate-900 hover:bg-slate-800 text-white font-bold py-4 px-8 rounded-xl shadow-lg transition-colors shrink-0" data-id="element-1430" data-mp="1svbst8s02eff">
              הרשמה ותשלום
            </button>
          </div>
        </section>
      </main>

      <ContactSection showTeam={false} showForm={false} data-id="element-1431" data-mp="1p8n7uwqdkx7b" />
      <Footer data-id="element-1432" data-mp="1p858hr8f22v6" />

      <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 left-6 z-50 inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20BA5A] text-white px-5 py-3.5 rounded-full shadow-lg transition-colors font-bold" aria-label="יצירת קשר בוואטסאפ להרשמה לבוקר גברים" data-id="element-1433" data-mp="1p6kfw75nwtzy">
        <MessageCircle className="w-5 h-5" data-id="element-1434" data-mp="16akn4u4v1mfb" />
        יצירת קשר
      </a>

      <MensMorningRegistration isFormOpen={isRegistrationOpen} onFormOpenChange={setIsRegistrationOpen} data-id="element-1435" data-mp="34pfaa9hrlq8t" />
    </div>;
}